import cloudinary from 'cloudinary-core';

export default () => new cloudinary.Cloudinary({
    cloud_name: process.env.CLOUDINARY_CLOUD_NAME,
    secure: true,
});
